import { AxiosResponse } from 'axios';
import { IFormCannedMessages } from '../types/cannedMessages';
import AxiosInstance from './AxiosInstance';

export const saveCannedMessages = async (props: IFormCannedMessages): Promise<AxiosResponse> =>
  AxiosInstance.post('canned-responses', props);
